import '../../styles/common/list.css'

const ListHeader = ({
  headers,
  showCheckbox,
  onCheckAll,
  isAllChecked,
  isPartiallyChecked,
  columnWidths = null,
}) => {
  return (
    <div className="list-header">
      {showCheckbox && (
        <div
          className={`list-header-cell ${columnWidths ? 'list-cell-fixed-width' : ''}`}
          style={columnWidths ? { width: '60px' } : {}}
        >
          <input
            type="checkbox"
            checked={isAllChecked}
            ref={(input) => {
              if (input) input.indeterminate = isPartiallyChecked
            }}
            onChange={onCheckAll}
            title="전체 선택/해제"
            style={{ width: '18px', height: '18px', cursor: 'pointer' }}
          />
        </div>
      )}
      {headers.map((header, index) => (
        <div
          key={index}
          className={`list-header-cell ${columnWidths ? 'list-cell-fixed-width' : ''}`}
          style={columnWidths ? { width: columnWidths[index] } : {}}
        >
          {header}
        </div>
      ))}
    </div>
  )
}

export default ListHeader
